/**
 * A Google Ads customer id as Google shows it: `123-456-7890`. Stored and sent
 * as digits only; this is for reading. An id that isn't ten digits is returned
 * as it came, rather than cut into a misleading shape.
 */
export function formatGoogleAdsId(id: string): string {
  return /^\d{10}$/.test(id) ? `${id.slice(0, 3)}-${id.slice(3, 6)}-${id.slice(6)}` : id
}
